<template>
<div>
    <div class='h-text-center h-mb-20'>
        <div class='b-base-title h-mt-10'>
            {{ $t('AUTH.CONFIRM_ACCOUNT.TITLE') }}
        </div>
    </div>
    <div>
        <form class='h-mt-15'
              @keyup.enter='sendDataToServer'>
            <FwFormInput
                class='h-mb-25'
                :fieldHasError='fieldHasErrorByRule(email, EMAIL, emailRules)'
                labelType='label-thin'
                :title='$t(`AUTH.SIGN_UP.FORM.EMAIL.LABEL`)'>
                <FwInput
                    :value='email'
                    type='text'
                    name='text'
                    inputStyle='gray'
                    placeholder='adresse@email.com'
                    :error='getFieldErrorTextByRule(email, EMAIL, emailRules)'
                    @update='value => email = value'
                    @input='clearServerErrorsBase(EMAIL)'
                    @blur='addCurrentInputToValidateArray(EMAIL)'>
                </FwInput>
            </FwFormInput>
            <FwFormInput
                class='h-mb-25'
                :fieldHasError='fieldHasErrorByRule(token, TOKEN, tokenRules)'
                labelType='label-thin'
                :title='$t(`AUTH.SIGN_UP.FORM.EMAIL_CODE.LABEL`)'>
                <FwInput
                    :value='token'
                    type='tel'
                    name='code'
                    :placeholder='$t(`AUTH.SIGN_UP.FORM.EMAIL_CODE.PLACEHOLDER`)'
                    inputStyle='gray'
                    :error='getFieldErrorTextByRule(token, TOKEN, tokenRules)'
                    @update='value => token = value'
                    @input='clearServerErrorsBase(TOKEN)'
                    @blur='addCurrentInputToValidateArray(TOKEN)'>
                </FwInput>
            </FwFormInput>
        </form>
    </div>
    <div class='b-text-error h-text-center h-fw-500'>
        {{ globalServerError }}
    </div>
    <div class='h-flex h-flex-center h-width-100p'>
        <FwButton
            class='h-mt-30'
            :disabled='!isFormValid'
            borderRadiusType='small-border'
            @click='sendDataToServer'>
            {{ $t('AUTH.SIGN_UP.FORM.BUTTON.NEXT') }}
        </FwButton>
    </div>
    <router-link
        :to='{ name: "LoginPage" }'
        class='b-url-with-arrow h-mt-20'>
        {{ $t('AUTH.LOGIN.LINK_TEXT') }}
        <FwIcon
            class='h-ml-15 b-url-with-arrow__icon'
            icon='arrow-right'
            size='10'
            color='#BEC7D3'>
        </FwIcon>
    </router-link>
</div>
</template>

<script lang='ts'>
import { Component, Emit, mixins, Prop, Vue } from 'vue-facing-decorator';
import { useValidation } from '@/composables/useValidation';
import { EMAIL, TOKEN } from '@/helpers/auth';

type SignUpPayloadType = {
    email: string,
    token: string,
}

@Component
export default class ConfirmMyAccountForm extends Vue {
    @Prop({ type: String, required: true }) readonly globalServerError!: string;
    [EMAIL]: string = '';
    [TOKEN]: string = '';
    EMAIL: string = EMAIL;
    TOKEN: string = TOKEN;
    emailRules: string[] = ['required', 'email'];
    tokenRules: string[] = ['required', 'length:5'];

    validation = useValidation();

    get getFieldErrorTextByRule() {
        return this.validation.getFieldErrorTextByRule;
    }

    get fieldHasErrorByRule() {
        return this.validation.fieldHasErrorByRule;
    }

    get clearServerErrorsBase() {
        return this.validation.clearServerErrorsBase;
    }

    get addCurrentInputToValidateArray() {
        return this.validation.addCurrentInputToValidateArray;
    }

    get isFormValid() {
        return this.validation.emailValidator({ value: this[EMAIL] }) &&
            this.validation.validateToken({ value: this[TOKEN] });
    }

    @Emit('submitForm')
    sendDataToServer(): SignUpPayloadType {
        return {
            [EMAIL]: this[EMAIL],
            [TOKEN]: this[TOKEN],
        };
    }
}
</script>
